/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import { mapQueueToBrand } from './brandHelper';

/**
     * This function builds the survey url with all the parameters related to the genesys agent
     * @param {object} data object containing all data related to the genesys conversation
     */
export const createSurveyLink = (data, featureFlags, localOrderId, customerData, setGenesysConvID, brand) => {
    if (!featureFlags['is-aigo-csat-survey-enabled']) return '';
    // if (data?.genesysConversationId) genesysConvID.current = data.genesysConversationId;
    if (data?.genesysConversationId) setGenesysConvID(data.genesysConversationId);
    const entities = data?.memberDetails?.entities;
    const extraEntities = data?.genesysAgentData;
    if (entities?.length) {
        const agents = entities.filter((e) => e.role === 'AGENT').sort((a, b) => new Date(b.joinDate) - new Date(a.joinDate));
        const ACD = entities.filter((e) => e.role === 'ACD')?.splice(-1)[0];        // extracting the last element
        const queue = ACD?.displayName || '';
        const customer = entities.filter((e) => e.role === 'CUSTOMER')[0];
        const customerAigoDetails = customer?.customFields?.aigoUserDetails?.split('~');
        let purpose = customerAigoDetails?.find((el) => el.includes('Purpose:'))?.split(': ');
        purpose = purpose?.length > 0 ? purpose[1] : '';
        // if no purpose found, then use subject, if not subject either, default to service.
        if (!purpose) purpose = customer?.customFields?.subject || 'service';

        let order = customerAigoDetails?.find((el) => el.includes('Order#:'))?.split(': ');
        order = order?.length > 0 ? order[1] : '';
        // if no order id from entities, take it from store
        if ((order === '(unknown)' || !order) && localOrderId?.current) {
            order = localOrderId?.current;
        }
        // if receive passport queue use user chat brand code
        const brandCode = (typeof queue === 'string' && (queue?.toLowerCase()?.includes('bumblebee') || queue === 'Chat - Passport')) ? brand.id : mapQueueToBrand(queue || '');
        const linkData = `conversationId=${data.genesysConversationId}&AgentFirstName=${data.displayName}&DivisionId${extraEntities?.divisionId}&CustomerEmail=${customerData?.profile?.email}&reason=${purpose}&BrandCode=${brandCode}&WebOrderNumber=${order}&ExternalDataReference=CHAT&Chat=YES&queue=${ACD.displayName}&agentId=${agents[0].id}`;
        const link = `https://1800flowers.co1.qualtrics.com/jfe/form/SV_djynujK4yFOEVQV?${linkData}`;
        // surveyLink.current = link;
        return link;
    }
    return '';
};

/**
 * This function will create the survey message.
 */
export const createSurveyMessage = (surveyLink, isAgent, featureFlags, localOrderId, brand, conversationId, customerProfileData) => {
    const botSurveyLink = 'https://1800flowers.co1.qualtrics.com/jfe/form/SV_1QQdpa1FwExqFmZ';

    if ((surveyLink.current && isAgent.current && featureFlags['is-aigo-csat-survey-enabled'])
        || (!isAgent.current && featureFlags['is-aigo-csat-survey-enabled'])) {
        const customerEmail = (customerProfileData?.email && typeof customerProfileData.email === 'string') ? customerProfileData?.email?.trim() : '';
        const customerFirstName = (customerProfileData?.firstName && typeof customerProfileData.firstName === 'string') ? customerProfileData?.firstName?.trim() : '';
        const customerLastName = (customerProfileData?.lastName && typeof customerProfileData.lastName === 'string') ? customerProfileData?.lastName?.trim() : '';
        const botParams = `?contactId=${conversationId}&ExternalDataReference=WEBCHAT&Chat=YES&agentId=AigoBot&WebOrderNumber=${localOrderId?.current || ''}&BrandCode=${brand.id}`;
        const customerDataBotParams = `&CustomerEmail=${customerEmail}&CustomerFirstName=${customerFirstName}&CustomerLastName=${customerLastName}`;
        const botSurveyLinkWithParams = `${botSurveyLink}${botParams}${customerDataBotParams}`;
        const surveyMessage = {
            msgType: 'SURVEY',
            responseMessage: {
                title: 'How did we do?',
                subtitle: 'Click here to take survey',
                url: isAgent.current ? surveyLink.current : botSurveyLinkWithParams,
                source: 'system',
            },
        };
        return surveyMessage;
    }
    return '';
};
